import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig, loginRequest } from '@/authConfig'

export const msalInstance = new PublicClientApplication(msalConfig)
export const portalScopes = loginRequest
